<template>
  <div class="home-box-swiper-container swiper-container">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="slide in slides">
        <div class="row-elements big">
          <div class="container">
            <div class="row flex-vertical-align-center">
              <div class="row-element col-l-6 col-m-6 col-s-12 order-s-2">
                <div
                  class="content"
                  v-html="slide.acf.home_page_case.text"
                ></div>
              </div>
              <div
                class="row-element image col-l-6 col-m-6 col-s-12 order-s-1"
                :style="{
                  'background-image':
                    'url( ' + slide.acf.home_page_case.image.url + ' )',
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home-box-swiper-pagination swiper-pagination"></div>
  </div>
</template>

<script>
export default {
  props: ["blockdata"],
  name: "block-home-slider",
  data() {
    return {
      slidesNumber: this.blockdata.slide,
      slides: null,
    };
  },
  mounted: function () {
    this.fetchData();
  },
  methods: {
    fetchData: function () {
      var self = this;
      $.get(
        self.$root.apiUrl + "wp-json/wp/v2/cases_studies",
        function (response) {
          var returnedSlides = response.filter((slide) => {
            return self.slidesNumber.indexOf(slide.id) != -1;
          });
          self.slides = returnedSlides;
          self.$root.dataReady = true;
        }
      )
        .done(function () {
          setTimeout(function () {
            var homeBoxSwiper = new Swiper(".home-box-swiper-container", {
              loop: true,
              spaceBetween: 5000,
              pagination: ".home-box-swiper-pagination",
            });
          }, 500);
        })
        .fail(function () {});
    },
  },
};
</script>

<style lang="scss" scope>
.swiper-container-horizontal > .swiper-pagination-bullets {
  width: auto;
  left: 120px;
  bottom: 60px;
}
.swiper-pagination-bullet {
  background: rgba(45, 168, 209, 1);
  width: 50px;
  height: 2px;
  border-radius: 0px;
  opacity: 0.4;
}
.swiper-pagination-bullet-active {
  background: rgba(45, 168, 209, 1);
  opacity: 1;
}
@media (max-width: 768px) {
  .swiper-container-horizontal > .swiper-pagination-bullets {
    width: auto;
    left: 25px;
    bottom: auto;
    top: 480px;
  }
  .evolving {
    .row-element {
      .content {
        padding-top: 70px;
      }
    }
  }
}
@media (max-width: 480px) {
  .swiper-container-horizontal > .swiper-pagination-bullets {
    top: 280px;
  }
}
</style>



// WEBPACK FOOTER //
// BlockHomeSlider.vue?424a6e46